import Vue from 'vue';

import LoaderVue from './Loader.vue';

export default function loaderComponent(_Vue: typeof Vue) {
  _Vue.component('AppLoader', LoaderVue);
}
